export class DevLogger {
  logError(error, ...args) {
    console.error(error, ...args);
  }
}